module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-05-e4f029602c0b854b04ce5e3967c45a9e.png";